var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section,index){return _c('Section',{key:index,attrs:{"data":section},on:{"productOk":function($event){return _vm.$emit('productOk', $event)},"sectionDeleteOk":function($event){return _vm.$emit('sectionDeleteOk',$event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }